import styled from "styled-components";

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 24px;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #757575;
  &:hover {
    color: #fe2f67;
  }
`;

export const ModalTitle = styled.h2`
  margin-top: 0;
  margin-bottom: 16px;
  color: #fe2f67;
  font-size: 1.5rem;
  text-align: center;
`;

export const ModalImageContainer = styled.div`
  width: 100%;
  height: 200px;
  margin-bottom: 20px;
  border-radius: 8px;
  background-color: #f0f0f0;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  span {
    color: #757575;
    font-size: 0.875rem;
  }
`;

export const EventDetailBody = styled.div`
  margin-bottom: 16px;
  line-height: 1.5;
  color: #333;
  padding: 0 10px;
`;

export const DetailInfoLine = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  color: #555;
  padding: 0 10px;
  
  svg {
    margin-right: 8px;
    color: #fe2f67;
    font-size: 20px;
  }
`;

export const PlaceInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 28px; // Alineación con el icono
`;

export const PlaceName = styled.span`
  font-weight: 600;
`;

export const PlaceAddress = styled.span`
  font-size: 0.875rem;
  color: #757575;
`;

//ViewPostsModal
export const ModalLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  color: #fe2f67;
  font-size: 1rem;
`;

export const ModalError = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  color: #ff0000;
  font-size: 1rem;
  text-align: center;
`;

export const PostsGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 16px;
  padding: 10px;
  max-height: 60vh;
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #fe2f67;
    border-radius: 4px;
  }
`;

export const PostCard = styled.div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
`;

export const PostImage = styled.img`
  width: 100%;
  height: 140px;
  object-fit: cover;
  display: block;
`;

export const PostDescription = styled.p`
  font-size: 0.85rem;
  padding: 8px;
  margin: 0;
  text-align: center;
  color: #333;
`;

export const PostUser = styled.p`
  padding: 0 12px 12px;
  margin: 0;
  color: #666;
  font-size: 12px;
  font-style: italic;
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  color: #757575;
  font-size: 0.9rem;
  text-align: center;
  
  svg {
    font-size: 2rem;
    margin-bottom: 1rem;
    color: #f0f0f0;
  }

  p {
    margin: 0;
    max-width: 80%;
  }
`;